import script from "./WelcomeStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeStep.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeStep.vue?vue&type=style&index=0&id=f24e84c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f24e84c4"]])

export default __exports__